// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__r6vWC","largestCol":"styles_largestCol__3w1N3","smallestCol":"styles_smallestCol__3WMaS"};